import React, {useEffect, useRef, useState} from 'react'
import classNames from 'classnames'
import {renderLeaseApplication} from '../../services/bluemoon'
import LoaderInline from '../common/LoaderInline'
import {
  LeaseApplication,
  LeaseApplicationStatus,
  LeaseUnitDetail,
  User
} from '../../types/app-types'
import {getLogger} from '../../services/logging'

interface ApplicationFormProps {
  leaseApplication: LeaseApplication
  leaseUnitDetail: LeaseUnitDetail
  leaseApplicant: User
  onUpdate: (updates: Record<string, any>) => void
}

const logger = getLogger('ApplicationForm')

const ApplicationForm = ({
  leaseApplication,
  leaseUnitDetail,
  leaseApplicant,
  onUpdate
}: ApplicationFormProps) => {
  const applicationFormContainer = useRef(null)
  const [isFormLoaded, setIsFormLoaded] = useState(false)

  useEffect(() => {
    if (
      applicationFormContainer &&
      leaseApplication &&
      leaseUnitDetail &&
      !isFormLoaded
    ) {
      const containerElementId = applicationFormContainer.current.id
      const propertyId = leaseApplication?.leasePropertyId
      const {firstName, lastName, email} = leaseApplicant
      const propertyAddress =
        `${leaseUnitDetail?.propertyAddress}, ${leaseUnitDetail?.propertyCity}, ` +
        `${leaseUnitDetail?.propertyState} ${leaseUnitDetail?.propertyZip}`
      const prefillData = {
        firstName,
        lastName,
        email,
        propertyAddress
      }

      logger.logInfo('Rendering bluemoon lease application form...', {
        applicationId: leaseApplication?.applicationId,
        prefillData
      })

      renderLeaseApplication(
        propertyId,
        containerElementId,
        leaseApplication?.applicationId,
        prefillData
      ).then(element => {
        element.addEventListener('onElementLoaded', (e: any) => {
          logger.logInfo('Bluemoon form loaded')
          setIsFormLoaded(true)
        })
        element.addEventListener('onApplicationSaved', (e: any) => {
          logger.logInfo('Bluemoon form info updated')
          const applicationId = String(e?.detail?.id || '')
          const applicationPropertyId = String(e?.detail.property_id || '')
          onUpdate({
            applicationStatus: LeaseApplicationStatus.FormInProgress,
            applicationId,
            applicationPropertyId
          })
        })
        element.addEventListener('onTransactionData', (e: any) => {
          logger.logInfo('Bluemoon form signature ready')
          const applicationSignatureId = String(e?.detail?.signer_key || '')
          onUpdate({
            applicationSignatureId
          })
        })
        element.addEventListener('onEsignatureComplete', (e: any) => {
          logger.logInfo('Bluemoon form signature completed')
          const applicationDocUrl = e?.detail?.document_url
          onUpdate({
            applicationStatus: LeaseApplicationStatus.FormCompleted,
            applicationDocUrl
          })
        })
      })
    }
  }, [applicationFormContainer, leaseApplication, leaseUnitDetail])

  return (
    <>
      {!isFormLoaded ? (
        <LoaderInline text="Loading lease application form..." />
      ) : (
        ''
      )}

      {isFormLoaded ? (
        <p className="mb-2">
          {' '}
          Please complete, review, and sign the lease application form:{' '}
        </p>
      ) : (
        ''
      )}

      <div
        id="applicationFormContainer"
        ref={applicationFormContainer}
        className={classNames({
          'border border-solid': isFormLoaded,
          'hidden': !isFormLoaded
        })}
        style={{
          'height': '720px'
        }}
      ></div>
    </>
  )
}

export default ApplicationForm
